// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__32oiq","range":"MonthRangeSwitch_range__2oiiw","disabled":"MonthRangeSwitch_disabled__3IWCf"};